<script>
  import { format } from 'svelte-i18n';

  import { Select } from '@client/components/select';

  export let status = false;

  let selected = '' + status;

  let items = [
    {
      label: $format('label.ENABLED'),
      value: 'true'
    },
    {
      label: $format('label.DISABLED'),
      value: 'false'
    }
  ];

  $: status = selected?.value === 'true';
</script>

<Select bind:items bind:value={selected} searchable={false} clearable={false} showChevron />

<style lang="scss" src="./plugin-status.scss"></style>
